/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HeartIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABXElEQVR4nO1Uu0oDURC9op0oam3jo1W0UOxSBQKbeaxwM2MiWKUW0Uqs1K/Rym8Qgz8gop2o+EA0FhK7lSurbsjDbLyChQcGBu7snHvO7B1j/pEG1toRIN1FklNkfQWSB2A5BtL1bHa5/6PO5XmSDSSpIMujq3XfAMlOEBSHmzYnKs4AyzWyRi3ignlpHsLCArJetaoDkksAnW68efvmURwvcbStcyR1St5t+b55lDK2Pwliz70SAOtJkqDmXQFJLWlR1b8CeUoqqPyCgsMvAtQ1/0OW1QQBDvi1SZ5zudJg3VtA1i1v/pNsNrzkTCbT52MWwHpkre1tui6CxeI4stx2P1i9AbBjTZsndtJUvMBS2qJVRJ01ncAtNSS9T+H5XT4szJk0ALCTSHLewc3PmGXCdAP3+yLpXuuBygHRypD5IXqQtZx8J3FedmfGF8KwNAos+06Ry701/vN4A9mUZm8na1PaAAAAAElFTkSuQmCC)
 */
export const HeartIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.47 21.73a.92.92 0 0 1-.94 0C9.43 20.48 1 15.09 1 8.75A5.75 5.75 0 0 1 6.75 3c2.34 0 3.88.9 5.25 2.26A6.98 6.98 0 0 1 17.25 3 5.75 5.75 0 0 1 23 8.75c0 6.34-8.42 11.73-10.53 12.98Z"
        className={colorClass}
      />
    </svg>
  );
};
